import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=415331d7&scoped=true&"
import script from "./about_us.vue?vue&type=script&lang=js&"
export * from "./about_us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415331d7",
  null
  
)

export default component.exports